// import React, { useEffect, useState, useCallback } from "react";
// import {
//   Box,
//   Button,
//   Divider,
//   Modal,
//   Stack,
//   TextField,
//   Typography,
//   // Card removed, using Paper directly
//   Grid,
//   Paper,
//   IconButton,
//   CircularProgress,
//   Checkbox,
//   Tooltip,
//   Table, // Added
//   TableBody, // Added
//   TableCell, // Added
//   TableContainer, // Kept
//   TableHead, // Added
//   TableRow, // Added
// } from "@mui/material";
// import AddCircleIcon from "@mui/icons-material/AddCircle";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import CloseIcon from "@mui/icons-material/Close";

// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
// import HOST_URL from "../../../utils/Url";
// import { useTranslation } from "react-i18next";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { toast } from "react-toastify";
// import ToastApp from "../../../ToastApp";
// import { DataGrid, GridColDef, GridToolbar, GridRowId } from "@mui/x-data-grid";

// // --- Modal Style ---
// const modalStyle = {
//   position: "absolute" as "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: { xs: '95%', sm: '90%', md: '85%', lg: '75%' }, // Adjusted responsive width
//   maxWidth: '1100px', // Slightly increased max width
//   maxHeight: '95vh', // Use maxHeight instead of fixed height
//   bgcolor: "background.paper",
//   border: "1px solid #ccc",
//   borderRadius: 2,
//   boxShadow: 24,
//   p: { xs: 2, sm: 3, md: 4 }, // Responsive padding
//   display: 'flex',
//   flexDirection: 'column',
// };

// const modalHeaderStyle = {
//     flexShrink: 0, // Prevent header from shrinking
//     borderBottom: 1, // Add border below header
//     borderColor: 'divider',
//     pb: 2, // Padding below header content
//     mb: 2, // Margin below header section
// };

// const modalContentStyle = {
//   overflowY: "auto", // Allow content scrolling
//   flexGrow: 1, // Allow content to take available space
//   // Apply scrollbar styling if desired (optional)
//   '&::-webkit-scrollbar': {
//     width: '8px',
//   },
//   '&::-webkit-scrollbar-track': {
//     backgroundColor: '#f1f1f1',
//     borderRadius: '4px',
//   },
//   '&::-webkit-scrollbar-thumb': {
//     backgroundColor: '#bdbdbd', // Softer scrollbar color
//     borderRadius: '4px',
//     '&:hover': {
//         backgroundColor: '#a5a5a5', // Darken on hover
//     },
//   },
// };

// // --- Interfaces ---
// interface RoleData {
//   id: string;
//   roleName: string;
// }

// interface ChildMenuPermission {
//   roleId: string;
//   menuId: string;
//   menuName: string;
//   parentId: number;
//   isAdd: boolean;
//   isEdit: boolean;
//   isDel: boolean;
//   isView: boolean;
//   isPrint: boolean;
//   isExport: boolean;
//   isRelease: boolean;
//   isPost: boolean;
// }

// // --- Helper Functions ---
// function createChildMenuData(
//   roleId: string, menuId: string, menuName: string, parentId: number,
//   isAdd: boolean, isEdit: boolean, isDel: boolean, isView: boolean,
//   isPrint: boolean, isExport: boolean, isRelease: boolean, isPost: boolean
// ): ChildMenuPermission {
//   return { roleId, menuId, menuName, parentId, isAdd, isEdit, isDel, isView, isPrint, isExport, isRelease, isPost };
// }

// // --- Component ---
// export default function RoleMaster() {
//   const { t } = useTranslation();
//   const navigate = useNavigate();

//   const [rows, setRows] = useState<RoleData[]>([]);
//   const [childMenuRecords, setChildMenuRecords] = useState<ChildMenuPermission[]>([]);
//   const [editID, setEditID] = useState<string>("-1");
//   const [isLoading, setIsLoading] = useState<boolean>(true);
//   const [isModalLoading, setIsModalLoading] = useState<boolean>(false); // Specific loader for modal content
//   const [open, setOpen] = useState<boolean>(false);
//   const [deleteRoleId, setDeleteRoleId] = useState<string | null>(null);

//   // --- Fetch Main Role List ---
//   const getList = useCallback(async () => {
//     setIsLoading(true);
//     try {
//       const response = await axios.post(`${HOST_URL.HOST_URL}RoleMaster/GetRoleMaster`, { roleId: "-1" });
//       if (response.data.isSuccess && Array.isArray(response.data.data)) {
//         const mappedData = response.data.data.map((item: any, index: number) => ({
//             srno: index + 1,
//             id: item.roleId.toString(),
//             roleName: item.roleName
//         }));
//         setRows(mappedData);
//       } else {
//         console.error("Error fetching roles:", response.data.mesg);
//         toast.error(t("text.ErrorFetchingRoles") + (response.data.mesg ? `: ${response.data.mesg}` : ''));
//         setRows([]);
//       }
//     } catch (error) {
//       console.error("API call failed:", error);
//       toast.error(t("text.ApiCallFailed"));
//       setRows([]);
//     } finally {
//       setIsLoading(false);
//     }
//   }, [t]);

//   // --- Fetch Base Menu Structure ---
//   const getBaseMenuStructure = useCallback(async () => {
//      setIsModalLoading(true);
//     try {
//       const response = await axios.post(`${HOST_URL.HOST_URL}Menu/GetChildMenuMaster`);
//       if (response.data.isSuccess && Array.isArray(response.data.data)) {
//         const menuData = response.data.data.map((item: any) =>
//           createChildMenuData(
//             "0", item.menuId, item.menuName, item.parentId,
//             item.isAdd ?? false, item.isEdit ?? false, item.isDel ?? false,
//             item.isView ?? false, item.isPrint ?? false, item.isExport ?? false,
//             item.isRelease ?? false, item.isPost ?? false
//           )
//         );
//         setChildMenuRecords(menuData);
//       } else {
//         console.error("Error fetching menu structure:", response.data.mesg);
//         toast.error(t("text.ErrorFetchingMenu") + (response.data.mesg ? `: ${response.data.mesg}` : ''));
//         setChildMenuRecords([]); // Clear on error
//       }
//     } catch (error) {
//       console.error("API call failed:", error);
//       toast.error(t("text.ApiCallFailed"));
//       setChildMenuRecords([]); // Clear on error
//     } finally {
//       setIsModalLoading(false);
//     }
//   }, [t]);

//   // --- Fetch Permissions for Specific Role ---
//   const getPermissionsForRole = useCallback(async (roleId: string) => {
//     setIsModalLoading(true);
//     try {
//       const response = await axios.post(`${HOST_URL.HOST_URL}RoleMaster/GetRoleMaster`, { roleId });
//       if (response.data.isSuccess && response.data.data.length > 0) {
//         const permissions = response.data.data[0]?.rolePermission;
//         if (Array.isArray(permissions) && permissions.length > 0) { // Check if permissions exist
//           const permissionData = permissions.map((item: any) =>
//             createChildMenuData(
//               roleId, item.menuId, item.menuName, item.parentId,
//               item.isAdd ?? false, item.isEdit ?? false, item.isDel ?? false,
//               item.isView ?? false, item.isPrint ?? false, item.isExport ?? false,
//               item.isRelease ?? false, item.isPost ?? false
//             )
//           );
//           setChildMenuRecords(permissionData);
//         } else {
//           console.warn("Permissions data missing or empty for role:", roleId, ". Loading base structure.");
//           toast.info(t("text.NoPermissionsFoundLoadingDefaults"));
//           await getBaseMenuStructure(); // Load default structure as fallback IF permissions are missing/empty
//         }
//       } else {
//         console.error("Error fetching role details:", response.data.mesg);
//         toast.error(t("text.ErrorFetchingRoleDetails") + (response.data.mesg ? `: ${response.data.mesg}` : ''));
//          setChildMenuRecords([]); // Clear on error
//          await getBaseMenuStructure(); // Attempt to load base structure even on role fetch error
//       }
//     } catch (error) {
//       console.error("API call failed:", error);
//       toast.error(t("text.ApiCallFailed"));
//        setChildMenuRecords([]); // Clear on error
//     } finally {
//       setIsModalLoading(false);
//     }
//   }, [t, getBaseMenuStructure]);

//   // --- Initial Load ---
//   useEffect(() => {
//     getList();
//   }, [getList]);

//   // --- Formik Setup ---
//   const validationSchema = Yup.object({
//     roleName: Yup.string().trim().required(t("text.reqRoleName")),
//   });

//   const formik = useFormik({
//     initialValues: {
//       roleId: "-1",
//       roleName: "",
//     },
//     validationSchema: validationSchema,
//     enableReinitialize: true,
//     onSubmit: async (values, { setSubmitting }) => {
//       const payload = {
//         ...values,
//         roleId: editID,
//         user_ID: "", // TODO: Add actual user ID if needed
//         rolePermission: childMenuRecords,
//       };
//       try {
//         const response = await axios.post(`${HOST_URL.HOST_URL2}RoleMaster/AddUpdateRoleMaster`, payload);
//         if (response.data.isSuccess) {
//           toast.success(editID === "-1" ? t("text.RoleAddedSuccess") : t("text.RoleUpdatedSuccess"));
//           handleClose();
//           getList();
//         } else {
//           toast.error(response.data.mesg || (editID === "-1" ? t("text.ErrorAddingRole") : t("text.ErrorUpdatingRole")));
//         }
//       } catch (error) {
//         console.error("API call failed:", error);
//         toast.error(t("text.ApiCallFailed"));
//       } finally {
//         setSubmitting(false); // Ensure submission state is reset
//       }
//     },
//   });

//   // --- Modal Handling ---
//   const handleOpen = async (roleToEdit: RoleData | null = null) => {
//     setChildMenuRecords([]); // Clear previous records immediately
//     setOpen(true); // Open modal first to show loader centered
//     setIsModalLoading(true); // Show loader while fetching data

//     if (roleToEdit) {
//       // EDIT MODE
//       setEditID(roleToEdit.id);
//       formik.setValues({ roleId: roleToEdit.id, roleName: roleToEdit.roleName }, false); // Don't trigger validation yet
//       await getPermissionsForRole(roleToEdit.id);
//     } else {
//       // ADD MODE
//       setEditID("-1");
//       formik.resetForm({ values: { roleId: "-1", roleName: "" } }); // Reset to initial empty state
//       await getBaseMenuStructure();
//     }
//     //setIsModalLoading(false); // Loader hidden within fetch functions
//   };

//   const handleClose = () => {
//     setOpen(false);
//     setEditID("-1");
//     formik.resetForm();
//     setChildMenuRecords([]);
//     setIsModalLoading(false); // Ensure loader is off on close
//   };

//   // --- Delete Handling ---
//   const handleDeleteRequest = (id: string) => {
//     setDeleteRoleId(id);
//     confirmDialog({
//       message: t("text.ConfirmDeleteRecord"),
//       header: t("text.DeleteConfirmation"),
//       icon: "pi pi-info-circle",
//       acceptClassName: "p-button-danger",
//       accept: handleDeleteConfirm,
//       reject: handleDeleteReject,
//     });
//   };

//   const handleDeleteConfirm = async () => {
//     if (!deleteRoleId) return;
//     try {
//       // IMPORTANT: Ensure the API expects 'roleId' as a string or number correctly
//       const response = await axios.post(`${HOST_URL.HOST_URL}RoleMaster/DeleteRoleMaster`, { roleId: parseInt(deleteRoleId) }); // Assuming API needs number
//       if (response.data.isSuccess) {
//         toast.success(response.data.mesg || t("text.RoleDeletedSuccess"));
//         getList();
//       } else {
//         toast.error(response.data.mesg || t("text.ErrorDeletingRole"));
//       }
//     } catch (error) {
//       console.error("API call failed:", error);
//       toast.error(t("text.ApiCallFailed"));
//     } finally {
//         setDeleteRoleId(null);
//     }
//   };

//   const handleDeleteReject = () => {
//     toast.info(t("text.DeleteOperationCancelled"), { autoClose: 3000 });
//     setDeleteRoleId(null);
//   };

//   // --- Permission Checkbox Handling ---
//   const handleSelectAll = (permissionKey: keyof ChildMenuPermission, checked: boolean) => {
//     if (typeof checked !== 'boolean') return; // Type guard
//     setChildMenuRecords((prevData) =>
//       prevData.map((item) => ({
//         ...item,
//         [permissionKey]: checked,
//       }))
//     );
//   };

//   const handleCheckboxChange = (menuId: string, permissionKey: keyof ChildMenuPermission) => {
//     setChildMenuRecords((prevData) =>
//       prevData.map((item) =>
//         item.menuId === menuId ? { ...item, [permissionKey]: !item[permissionKey] } : item
//       )
//     );
//   };

//   // --- DataGrid Columns ---
//   const columns: GridColDef[] = [
//      {
//       field: "srno",
//       headerName: t("text.SrNo"),
//       minWidth: 80,
//       align: 'center',
//       headerAlign: 'center',
//       filterable: false,
//       sortable: false,
//     },
//     {
//       field: 'roleName',
//       headerName: t('text.RoleName'),
//       minWidth: 250,
//       flex: 1,
//     },
//     {
//         field: 'actions',
//         headerName: t('text.Action'),
//         minWidth: 130, // Adjusted width
//         sortable: false,
//         filterable: false,
//         disableColumnMenu: true,
//         align: 'center',
//         headerAlign: 'center',
//         renderCell: (params) => ( // params already has type GridRenderCellParams
//           <Stack direction="row" spacing={1} justifyContent="center">
//              <Tooltip title={t('text.Edit')} arrow>
//                 <IconButton
//                     onClick={() => handleOpen(params.row as RoleData)}
//                     color="primary"
//                     size="small"
//                     aria-label={t('ariaLabel.editRole', { roleName: params.row.roleName })}
//                 >
//                     <EditIcon fontSize="inherit" />
//                 </IconButton>
//             </Tooltip>
//             <Tooltip title={t('text.delete')} arrow>
//                 <IconButton
//                     onClick={() => handleDeleteRequest(params.row.id)}
//                     color="error"
//                     size="small"
//                      aria-label={t('ariaLabel.deleteRole', { roleName: params.row.roleName })}
//                  >
//                     <DeleteIcon fontSize="inherit"/>
//                 </IconButton>
//              </Tooltip>
//           </Stack>
//         ),
//       },
//   ];

//   // --- Permission Table Columns Definition (for Modal) ---
//   const permissionColumns: { key: keyof ChildMenuPermission; label: string }[] = [
//     { key: "isAdd", label: t("text.add") },
//     { key: "isEdit", label: t("text.Edit") },
//     { key: "isDel", label: t("text.delete") },
//     { key: "isView", label: t("text.View") },
//     { key: "isPrint", label: t("text.Print") },
//     { key: "isExport", label: t("text.Export") },
//     { key: "isRelease", label: t("text.Release") },
//     { key: "isPost", label: t("text.Post") },
//   ];

//   // --- Render ---
//   return (
//     <>
//       <ToastApp />
//       <ConfirmDialog />

//       <Paper // Use Paper as the main container
//         sx={{
//           width: "100%",
//           overflow: "hidden", // Keep overflow hidden here
//           p: { xs: 1, sm: 2, md: 3 }, // Responsive padding
//           mt: 2, // Margin top
//           mb: 2, // Margin bottom
//           boxShadow: 3, // Apply elevation shadow
//            // DataGrid Header Styling
//           "& .MuiDataGrid-columnHeaders": {
//             backgroundColor: 'primary.main', // Use theme primary color
//             color: 'primary.contrastText', // Contrast text color
//             fontSize: '1rem',
//             fontWeight: '600',
//            },
//            // Toolbar styling
//            "& .MuiDataGrid-toolbarContainer": {
//               padding: '8px', // Add some padding to the toolbar
//               borderBottom: '1px solid', // Separator line
//               borderColor: 'divider',
//             },
//            "& .MuiButton-root": { // Style buttons inside toolbar if needed
//               // marginRight: 1,
//            },
//            "& .MuiSvgIcon-root": {
//               // fontSize: '1.2rem',
//            }
//         }}
//       >
//         <Typography variant="h5" gutterBottom sx={{ mb: 2, fontWeight: 'medium' }}>
//           {t("text.RoleMaster")}
//         </Typography>
//         {/* <Divider sx={{ mb: 2 }} /> */} {/* Divider might be redundant with Paper separation */}

//         <Stack direction="row" spacing={1.5} sx={{ mb: 2 }}>
//           <Button
//             onClick={() => handleOpen()}
//             variant="contained"
//             startIcon={<AddCircleIcon />}
//             color="primary"
//             size="medium" // Standard button size
//           >
//             {t("text.add")}
//           </Button>
//           {/* Add Print/Export buttons here if needed */}
//         </Stack>

//         {isLoading ? (
//            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 400, p: 3 }}>
//               <CircularProgress />
//           </Box>
//         ) : (
//           <Box sx={{ height: 'auto', width: '100%' }}>
//             <DataGrid
//               rows={rows}
//               columns={columns}
//               autoHeight // Adjust height based on content
//               getRowId={(row) => row.id}
//               initialState={{
//                   pagination: { paginationModel: { pageSize: 10 } },
//                }}
//               pageSizeOptions={[10, 25, 50, 100]} // Adjusted page size options
//               slots={{
//                   toolbar: GridToolbar,
//                }}
//               slotProps={{
//                   toolbar: {
//                       showQuickFilter: true,
//                       quickFilterProps: { debounceMs: 500 }, // Add debounce to quick filter
//                       printOptions: { disableToolbarButton: true },
//                       csvOptions: { disableToolbarButton: true },
//                   },
//               }}
//               sx={{
//                   border: 1, // Ensure border is visible
//                   borderColor: 'divider',
//                   // Remove focus outlines for cleaner look (optional)
//                   '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
//                       outline: 'none',
//                   },
//                    '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
//                        outline: 'none',
//                   },
//               }}
//               density="compact"
//               disableRowSelectionOnClick
//            />
//           </Box>
//         )}
//       </Paper>

//       {/* --- Add/Edit Modal --- */}
//       <Modal open={open} onClose={handleClose} aria-labelledby="role-modal-title">
//         <Box sx={modalStyle}>
//           {/* Modal Header */}
//           <Stack direction="row" justifyContent="space-between" alignItems="center" sx={modalHeaderStyle}>
//             <Typography variant="h6" id="role-modal-title" component="h2" sx={{ fontWeight: 'medium' }}>
//                 {editID === "-1" ? t("text.AddNewRole") : t("text.EditRole")}
//             </Typography>
//             <IconButton aria-label={t("ariaLabel.closeModal")} onClick={handleClose} size="small">
//                 <CloseIcon />
//             </IconButton>
//           </Stack>

//           {/* Modal Content */}
//           <Box sx={modalContentStyle}>
//             <form onSubmit={formik.handleSubmit} noValidate>
//                 {/* Role Name Input and Action Buttons */}
//                 <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }}>
//                     <Grid item xs={12} sm={6} md={5} lg={4}>
//                       <TextField
//                         fullWidth
//                         required
//                         id="roleName"
//                         name="roleName"
//                         label={t("text.enterRoleName")}
//                         value={formik.values.roleName}
//                         onChange={formik.handleChange}
//                         onBlur={formik.handleBlur}
//                         error={formik.touched.roleName && Boolean(formik.errors.roleName)}
//                         helperText={formik.touched.roleName && formik.errors.roleName}
//                         variant="outlined"
//                         size="small"
//                         autoFocus // Focus on the first field
//                       />
//                     </Grid>
//                     <Grid item xs={6} sm={3} md={2} lg={2}>
//                       <Button
//                         type="submit"
//                         fullWidth
//                         variant="contained"
//                         color="primary"
//                         disabled={formik.isSubmitting || !formik.isValid || isModalLoading}
//                        >
//                         {formik.isSubmitting ? <CircularProgress size={24} color="inherit" /> : (editID === "-1" ? t("text.save") : t("text.update"))}
//                       </Button>
//                     </Grid>
//                     <Grid item xs={6} sm={3} md={2} lg={2}>
//                       <Button
//                         type="button"
//                         fullWidth
//                         variant="outlined"
//                         color="secondary"
//                         onClick={() => formik.resetForm()}
//                         disabled={formik.isSubmitting || isModalLoading}
//                        >
//                         {t("text.reset")}
//                       </Button>
//                     </Grid>
//                      {/* Optional: Add a cancel button */}
//                     {/* <Grid item xs={12} sm={3} md={2} lg={2}>
//                       <Button
//                         type="button"
//                         fullWidth
//                         variant="text"
//                         onClick={handleClose}
//                        >
//                         {t("text.cancel")}
//                       </Button>
//                     </Grid> */}
//                 </Grid>

//                 {/* Permissions Section */}
//                 <Typography variant="subtitle1" sx={{ mb: 1.5, fontWeight: 'medium' }}>
//                   {t("text.AssignPermissions")}
//                 </Typography>

//                 {isModalLoading ? (
//                      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
//                          <CircularProgress />
//                      </Box>
//                  ) : (
//                     <TableContainer component={Paper} elevation={1} sx={{ maxHeight: "calc(95vh - 280px)", border: 1, borderColor: 'divider' }}> {/* Adjust maxHeight calculation based on other elements */}
//                        <Table stickyHeader size="small" aria-label={t('ariaLabel.permissionsTable')}>
//                          <TableHead>
//                             <TableRow sx={{ '& th': { fontWeight: '600', backgroundColor: 'grey.200', py: 0.5 } }}> {/* Sticky header styling */}
//                                <TableCell sx={{ textAlign: 'left', minWidth: { xs: 120, sm: 150 } }}>{t("text.MenuName")}</TableCell>
//                                {permissionColumns.map((col) => (
//                                  <TableCell key={col.key} align="center" sx={{ px: { xs: 0.5, sm: 1 }, width: { xs: 60, sm: 80 } }}> {/* Adjust padding/width */}
//                                    <Tooltip title={t('tooltip.selectAll', { permission: col.label })} arrow placement="top">
//                                       <Stack direction="column" alignItems="center" spacing={0}>
//                                         <Typography variant="caption" sx={{ lineHeight: 1.1, mb: -0.5 }}>{col.label}</Typography>
//                                         <Checkbox
//                                             size="small"
//                                             // Determine indeterminate state if needed, otherwise just checked
//                                             checked={childMenuRecords.length > 0 && childMenuRecords.every((item) => !!item[col.key])}
//                                             indeterminate={
//                                                 childMenuRecords.length > 0 &&
//                                                 !childMenuRecords.every((item) => !!item[col.key]) && // Not all checked
//                                                 childMenuRecords.some((item) => !!item[col.key]) // But some are checked
//                                             }
//                                             onChange={(e) => handleSelectAll(col.key, e.target.checked)}
//                                             inputProps={{ 'aria-label': t('ariaLabel.selectAllPermission', { permission: col.label }) }}
//                                             sx={{ p: 0.5 }}
//                                         />
//                                       </Stack>
//                                    </Tooltip>
//                                  </TableCell>
//                                ))}
//                             </TableRow>
//                          </TableHead>
//                          <TableBody>
//                            {childMenuRecords.length === 0 && !isModalLoading ? (
//                              <TableRow>
//                                 <TableCell colSpan={permissionColumns.length + 1} align="center" sx={{ py: 4 }}>
//                                     {t('text.NoPermissionsDataFound')} {/* More specific message */}
//                                 </TableCell>
//                              </TableRow>
//                             ) : (
//                                 childMenuRecords.map((row, index) => (
//                                 <TableRow
//                                     key={row.menuId || `menu-${index}`}
//                                     hover
//                                     sx={{ '&:nth-of-type(odd)': { backgroundColor: 'action.hover' } }}
//                                 >
//                                     <TableCell component="th" scope="row" sx={{ py: 0.5, px: 1 }}>
//                                         {row.menuName}
//                                     </TableCell>
//                                     {permissionColumns.map((col) => (
//                                         <TableCell key={col.key} align="center" sx={{ p: 0 }}> {/* Minimal padding */}
//                                             <Checkbox
//                                                 size="small"
//                                                 checked={!!row[col.key]} // Ensure boolean value
//                                                 onChange={() => handleCheckboxChange(row.menuId, col.key)}
//                                                 name={`${col.key}_${row.menuId}`}
//                                                 inputProps={{ 'aria-label': t('ariaLabel.togglePermission', { permission: col.label, menu: row.menuName }) }}
//                                                 sx={{ p: 0.5 }} // Adjust padding if needed
//                                             />
//                                         </TableCell>
//                                     ))}
//                                 </TableRow>
//                                 ))
//                             )}
//                          </TableBody>
//                        </Table>
//                     </TableContainer>
//                  )}
//              </form>
//           </Box> {/* End scrollable content */}
//         </Box>
//       </Modal>
//     </>
//   );
// }

import React, { useEffect, useState, useCallback } from "react";
import {
  Box,
  Button,
  Divider,
  Modal,
  Stack,
  TextField,
  Typography,
  // Card removed, using Paper directly
  Grid,
  Paper,
  IconButton,
  CircularProgress,
  Checkbox,
  Tooltip,
  Table, // Added
  TableBody, // Added
  TableCell, // Added
  TableContainer, // Kept
  TableHead, // Added
  TableRow, // Added
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";

import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import HOST_URL from "../../../utils/Url";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import { DataGrid, GridColDef, GridToolbar, GridRowId } from "@mui/x-data-grid";
import { secureGetItem } from "../../../utils/encryption";

// --- Modal Style ---
const modalStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: '95%', sm: '90%', md: '85%', lg: '75%' }, // Adjusted responsive width
  maxWidth: '1100px', // Slightly increased max width
  maxHeight: '95vh', // Use maxHeight instead of fixed height
  bgcolor: "background.paper",
  border: "1px solid #ccc",
  borderRadius: 2,
  boxShadow: 24,
  p: { xs: 2, sm: 3, md: 4 }, // Responsive padding
  display: 'flex',
  flexDirection: 'column',
};

const modalHeaderStyle = {
    flexShrink: 0, // Prevent header from shrinking
    borderBottom: 1, // Add border below header
    borderColor: 'divider',
    pb: 2, // Padding below header content
    mb: 2, // Margin below header section
};

const modalContentStyle = {
  overflowY: "auto", // Allow content scrolling
  flexGrow: 1, // Allow content to take available space
  // Apply scrollbar styling if desired (optional)
  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: '#f1f1f1',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#bdbdbd', // Softer scrollbar color
    borderRadius: '4px',
    '&:hover': {
        backgroundColor: '#a5a5a5', // Darken on hover
    },
  },
};

// --- Interfaces ---
interface MenuPermission {
  isAdd: boolean;
  isEdit: boolean;
  isPrint: boolean;
  isDel: boolean;
}

interface RoleData {
  id: string;
  roleName: string;
}

interface ChildMenuPermission {
  roleId: string;
  menuId: string;
  menuName: string;
  parentId: number;
  isAdd: boolean;
  isEdit: boolean;
  isDel: boolean;
  isView: boolean;
  isPrint: boolean;
  isExport: boolean;
  isRelease: boolean;
  isPost: boolean;
}

// --- Helper Functions ---
function createChildMenuData(
  roleId: string, menuId: string, menuName: string, parentId: number,
  isAdd: boolean, isEdit: boolean, isDel: boolean, isView: boolean,
  isPrint: boolean, isExport: boolean, isRelease: boolean, isPost: boolean
): ChildMenuPermission {
  return { roleId, menuId, menuName, parentId, isAdd, isEdit, isDel, isView, isPrint, isExport, isRelease, isPost };
}

// --- Component ---
export default function RoleMaster() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const [rows, setRows] = useState<RoleData[]>([]);
  const [childMenuRecords, setChildMenuRecords] = useState<ChildMenuPermission[]>([]);
  const [editID, setEditID] = useState<string>("-1");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isModalLoading, setIsModalLoading] = useState<boolean>(false); // Specific loader for modal content
  const [open, setOpen] = useState<boolean>(false);
  const [deleteRoleId, setDeleteRoleId] = useState<string | null>(null);
  const [permissionLoaded, setPermissionLoaded] = useState(false);
  const [permissionData, setPermissionData] = useState<MenuPermission>({
    isAdd: false,
    isEdit: false,
    isPrint: false,
    isDel: false,
  });

  useEffect(() => {
    const data = secureGetItem("userdata");

    if (data && data.length > 0) {
      const userPermissionData = data[0]?.userPermission;
      const menudata = userPermissionData?.[0]?.parentMenu || [];

      for (let i = 0; i < menudata.length; i++) {
        const childMenudata = menudata[i]?.childMenu || [];
        const pathrow = childMenudata.find(
          (x: any) => x.path === location.pathname
        );

        if (pathrow) {
          setPermissionData({
            isAdd: pathrow.isAdd,
            isEdit: pathrow.isEdit,
            isPrint: pathrow.isPrint,
            isDel: pathrow.isDel,
          });
          break;
        }
      }
    }
    setPermissionLoaded(true);
  }, [location.pathname]);

  // --- Fetch Main Role List ---
  const getList = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(`${HOST_URL.HOST_URL}RoleMaster/GetRoleMaster`, { roleId: "-1" });
      if (response.data.isSuccess && Array.isArray(response.data.data)) {
        const mappedData = response.data.data.map((item: any, index: number) => ({
            srno: index + 1,
            id: item.roleId.toString(),
            roleName: item.roleName
        }));
        setRows(mappedData);
      } else {
        console.error("Error fetching roles:", response.data.mesg);
        toast.error(t("text.ErrorFetchingRoles") + (response.data.mesg ? `: ${response.data.mesg}` : ''));
        setRows([]);
      }
    } catch (error) {
      console.error("API call failed:", error);
      toast.error(t("text.ApiCallFailed"));
      setRows([]);
    } finally {
      setIsLoading(false);
    }
  }, [t]);

  // --- Fetch Base Menu Structure ---
  const getBaseMenuStructure = useCallback(async () => {
     setIsModalLoading(true);
    try {
      const response = await axios.post(`${HOST_URL.HOST_URL}Menu/GetChildMenuMaster`);
      if (response.data.isSuccess && Array.isArray(response.data.data)) {
        const menuData = response.data.data.map((item: any) =>
          createChildMenuData(
            "0", item.menuId, item.menuName, item.parentId,
            item.isAdd ?? false, item.isEdit ?? false, item.isDel ?? false,
            item.isView ?? false, item.isPrint ?? false, item.isExport ?? false,
            item.isRelease ?? false, item.isPost ?? false
          )
        );
        setChildMenuRecords(menuData);
      } else {
        console.error("Error fetching menu structure:", response.data.mesg);
        toast.error(t("text.ErrorFetchingMenu") + (response.data.mesg ? `: ${response.data.mesg}` : ''));
        setChildMenuRecords([]); // Clear on error
      }
    } catch (error) {
      console.error("API call failed:", error);
      toast.error(t("text.ApiCallFailed"));
      setChildMenuRecords([]); // Clear on error
    } finally {
      setIsModalLoading(false);
    }
  }, [t]);

  // --- Fetch Permissions for Specific Role ---
  const getPermissionsForRole = useCallback(async (roleId: string) => {
    setIsModalLoading(true);
    try {
      const response = await axios.post(`${HOST_URL.HOST_URL}RoleMaster/GetRoleMaster`, { roleId });
      if (response.data.isSuccess && response.data.data.length > 0) {
        const permissions = response.data.data[0]?.rolePermission;
        if (Array.isArray(permissions) && permissions.length > 0) { // Check if permissions exist
          const permissionData = permissions.map((item: any) =>
            createChildMenuData(
              roleId, item.menuId, item.menuName, item.parentId,
              item.isAdd ?? false, item.isEdit ?? false, item.isDel ?? false,
              item.isView ?? false, item.isPrint ?? false, item.isExport ?? false,
              item.isRelease ?? false, item.isPost ?? false
            )
          );
          setChildMenuRecords(permissionData);
        } else {
          console.warn("Permissions data missing or empty for role:", roleId, ". Loading base structure.");
          toast.info(t("text.NoPermissionsFoundLoadingDefaults"));
          await getBaseMenuStructure(); // Load default structure as fallback IF permissions are missing/empty
        }
      } else {
        console.error("Error fetching role details:", response.data.mesg);
        toast.error(t("text.ErrorFetchingRoleDetails") + (response.data.mesg ? `: ${response.data.mesg}` : ''));
         setChildMenuRecords([]); // Clear on error
         await getBaseMenuStructure(); // Attempt to load base structure even on role fetch error
      }
    } catch (error) {
      console.error("API call failed:", error);
      toast.error(t("text.ApiCallFailed"));
       setChildMenuRecords([]); // Clear on error
    } finally {
      setIsModalLoading(false);
    }
  }, [t, getBaseMenuStructure]);

  // --- Initial Load ---
  useEffect(() => {
    if (permissionLoaded) {
      getList();
    }
  }, [getList, permissionLoaded]);

  // --- Formik Setup ---
  const validationSchema = Yup.object({
    roleName: Yup.string().trim().required(t("text.reqRoleName")),
  });

  const formik = useFormik({
    initialValues: {
      roleId: "-1",
      roleName: "",
    },
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: async (values, { setSubmitting }) => {
      const payload = {
        ...values,
        roleId: editID,
        user_ID: "", // TODO: Add actual user ID if needed
        rolePermission: childMenuRecords,
      };
      try {
        const response = await axios.post(`${HOST_URL.HOST_URL2}RoleMaster/AddUpdateRoleMaster`, payload);
        if (response.data.isSuccess) {
          toast.success(editID === "-1" ? t("text.RoleAddedSuccess") : t("text.RoleUpdatedSuccess"));
          handleClose();
          getList();
        } else {
          toast.error(response.data.mesg || (editID === "-1" ? t("text.ErrorAddingRole") : t("text.ErrorUpdatingRole")));
        }
      } catch (error) {
        console.error("API call failed:", error);
        toast.error(t("text.ApiCallFailed"));
      } finally {
        setSubmitting(false); // Ensure submission state is reset
      }
    },
  });

  // --- Modal Handling ---
  const handleOpen = async (roleToEdit: RoleData | null = null) => {
    if (roleToEdit && !permissionData?.isEdit) {
      toast.error("You don't have edit permission");
      return;
    }
    if (!roleToEdit && !permissionData?.isAdd) {
      toast.error("You don't have add permission");
      return;
    }
    
    setChildMenuRecords([]); // Clear previous records immediately
    setOpen(true); // Open modal first to show loader centered
    setIsModalLoading(true); // Show loader while fetching data

    if (roleToEdit) {
      // EDIT MODE
      setEditID(roleToEdit.id);
      formik.setValues({ roleId: roleToEdit.id, roleName: roleToEdit.roleName }, false); // Don't trigger validation yet
      await getPermissionsForRole(roleToEdit.id);
    } else {
      // ADD MODE
      setEditID("-1");
      formik.resetForm({ values: { roleId: "-1", roleName: "" } }); // Reset to initial empty state
      await getBaseMenuStructure();
    }
    //setIsModalLoading(false); // Loader hidden within fetch functions
  };

  const handleClose = () => {
    setOpen(false);
    setEditID("-1");
    formik.resetForm();
    setChildMenuRecords([]);
    setIsModalLoading(false); // Ensure loader is off on close
  };

  // --- Delete Handling ---
  const handleDeleteRequest = (id: string) => {
    if (!permissionData?.isDel) {
      toast.error("You don't have delete permission");
      return;
    }
    setDeleteRoleId(id);
    confirmDialog({
      message: t("text.ConfirmDeleteRecord"),
      header: t("text.DeleteConfirmation"),
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: handleDeleteConfirm,
      reject: handleDeleteReject,
    });
  };

  const handleDeleteConfirm = async () => {
    if (!deleteRoleId) return;
    try {
      // IMPORTANT: Ensure the API expects 'roleId' as a string or number correctly
      const response = await axios.post(`${HOST_URL.HOST_URL}RoleMaster/DeleteRoleMaster`, { roleId: parseInt(deleteRoleId) }); // Assuming API needs number
      if (response.data.isSuccess) {
        toast.success(response.data.mesg || t("text.RoleDeletedSuccess"));
        getList();
      } else {
        toast.error(response.data.mesg || t("text.ErrorDeletingRole"));
      }
    } catch (error) {
      console.error("API call failed:", error);
      toast.error(t("text.ApiCallFailed"));
    } finally {
        setDeleteRoleId(null);
    }
  };

  const handleDeleteReject = () => {
    toast.info(t("text.DeleteOperationCancelled"), { autoClose: 3000 });
    setDeleteRoleId(null);
  };

  // --- Permission Checkbox Handling ---
  const handleSelectAll = (permissionKey: keyof ChildMenuPermission, checked: boolean) => {
    if (typeof checked !== 'boolean') return; // Type guard
    setChildMenuRecords((prevData) =>
      prevData.map((item) => ({
        ...item,
        [permissionKey]: checked,
      }))
    );
  };

  const handleCheckboxChange = (menuId: string, permissionKey: keyof ChildMenuPermission) => {
    setChildMenuRecords((prevData) =>
      prevData.map((item) =>
        item.menuId === menuId ? { ...item, [permissionKey]: !item[permissionKey] } : item
      )
    );
  };

  // --- DataGrid Columns ---
  const columns: GridColDef[] = [
     {
      field: "srno",
      headerName: t("text.SrNo"),
      minWidth: 80,
      align: 'center',
      headerAlign: 'center',
      filterable: false,
      sortable: false,
    },
    {
      field: 'roleName',
      headerName: t('text.RoleName'),
      minWidth: 250,
      flex: 1,
    },
    {
        field: 'actions',
        headerName: t('text.Action'),
        minWidth: 130, // Adjusted width
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        align: 'center',
        headerAlign: 'center',
        renderCell: (params) => ( // params already has type GridRenderCellParams
          <Stack direction="row" spacing={1} justifyContent="center">
             {permissionData?.isEdit && (
                <Tooltip title={t('text.Edit')} arrow>
                  <IconButton
                      onClick={() => handleOpen(params.row as RoleData)}
                      color="primary"
                      size="small"
                      aria-label={t('ariaLabel.editRole', { roleName: params.row.roleName })}
                  >
                      <EditIcon fontSize="inherit" />
                  </IconButton>
                </Tooltip>
              )}
              {permissionData?.isDel && (
                <Tooltip title={t('text.delete')} arrow>
                  <IconButton
                      onClick={() => handleDeleteRequest(params.row.id)}
                      color="error"
                      size="small"
                       aria-label={t('ariaLabel.deleteRole', { roleName: params.row.roleName })}
                   >
                      <DeleteIcon fontSize="inherit"/>
                  </IconButton>
                </Tooltip>
              )}
          </Stack>
        ),
      },
  ];

  // --- Permission Table Columns Definition (for Modal) ---
  const permissionColumns: { key: keyof ChildMenuPermission; label: string }[] = [
    { key: "isAdd", label: t("text.add") },
    { key: "isEdit", label: t("text.Edit") },
    { key: "isDel", label: t("text.delete") },
    { key: "isView", label: t("text.View") },
    { key: "isPrint", label: t("text.Print") },
    { key: "isExport", label: t("text.Export") },
    { key: "isRelease", label: t("text.Release") },
    { key: "isPost", label: t("text.Post") },
  ];

  // --- Render ---
  return (
    <>
      <ToastApp />
      <ConfirmDialog />

      <Paper // Use Paper as the main container
        sx={{
          width: "100%",
          overflow: "hidden", // Keep overflow hidden here
          p: { xs: 1, sm: 2, md: 3 }, // Responsive padding
          mt: 2, // Margin top
          mb: 2, // Margin bottom
          boxShadow: 3, // Apply elevation shadow
           // DataGrid Header Styling
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: 'primary.main', // Use theme primary color
            color: 'primary.contrastText', // Contrast text color
            fontSize: '1rem',
            fontWeight: '600',
           },
           // Toolbar styling
           "& .MuiDataGrid-toolbarContainer": {
              padding: '8px', // Add some padding to the toolbar
              borderBottom: '1px solid', // Separator line
              borderColor: 'divider',
            },
           "& .MuiButton-root": { // Style buttons inside toolbar if needed
              // marginRight: 1,
           },
           "& .MuiSvgIcon-root": {
              // fontSize: '1.2rem',
           }
        }}
      >
        <Typography variant="h5" gutterBottom sx={{ mb: 2, fontWeight: 'medium' }}>
          {t("text.RoleMaster")}
        </Typography>
        {/* <Divider sx={{ mb: 2 }} /> */} {/* Divider might be redundant with Paper separation */}

        <Stack direction="row" spacing={1.5} sx={{ mb: 2 }}>
          {permissionData?.isAdd && (
            <Button
              onClick={() => handleOpen()}
              variant="contained"
              startIcon={<AddCircleIcon />}
              color="primary"
              size="medium" // Standard button size
            >
              {t("text.add")}
            </Button>
          )}
          {/* Add Print/Export buttons here if needed */}
        </Stack>

        {isLoading ? (
           <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 400, p: 3 }}>
              <CircularProgress />
          </Box>
        ) : (
          <Box sx={{ height: 'auto', width: '100%' }}>
            <DataGrid
              rows={rows}
              columns={columns}
              autoHeight // Adjust height based on content
              getRowId={(row) => row.id}
              initialState={{
                  pagination: { paginationModel: { pageSize: 10 } },
               }}
              pageSizeOptions={[10, 25, 50, 100]} // Adjusted page size options
              slots={{
                  toolbar: GridToolbar,
               }}
              slotProps={{
                  toolbar: {
                      showQuickFilter: true,
                      quickFilterProps: { debounceMs: 500 }, // Add debounce to quick filter
                      printOptions: { disableToolbarButton: true },
                      csvOptions: { disableToolbarButton: true },
                  },
              }}
              sx={{
                  border: 1, // Ensure border is visible
                  borderColor: 'divider',
                  // Remove focus outlines for cleaner look (optional)
                  '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
                      outline: 'none',
                  },
                   '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                       outline: 'none',
                  },
              }}
              density="compact"
              disableRowSelectionOnClick
           />
          </Box>
        )}
      </Paper>

      {/* --- Add/Edit Modal --- */}
      <Modal open={open} onClose={handleClose} aria-labelledby="role-modal-title">
        <Box sx={modalStyle}>
          {/* Modal Header */}
          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={modalHeaderStyle}>
            <Typography variant="h6" id="role-modal-title" component="h2" sx={{ fontWeight: 'medium' }}>
                {editID === "-1" ? t("text.AddNewRole") : t("text.EditRole")}
            </Typography>
            <IconButton aria-label={t("ariaLabel.closeModal")} onClick={handleClose} size="small">
                <CloseIcon />
            </IconButton>
          </Stack>

          {/* Modal Content */}
          <Box sx={modalContentStyle}>
            <form onSubmit={formik.handleSubmit} noValidate>
                {/* Role Name Input and Action Buttons */}
                <Grid container spacing={2} alignItems="center" sx={{ mb: 3,mt:1 }}>
                    <Grid item xs={12} sm={6} md={5} lg={4}>
                      <TextField
                        fullWidth
                        required
                        id="roleName"
                        name="roleName"
                        label={t("text.enterRoleName")}
                        value={formik.values.roleName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.roleName && Boolean(formik.errors.roleName)}
                        helperText={formik.touched.roleName && formik.errors.roleName}
                        variant="outlined"
                        size="small"
                        autoFocus // Focus on the first field
                      />
                    </Grid>
                    <Grid item xs={6} sm={3} md={2} lg={2}>
                      <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        disabled={formik.isSubmitting || !formik.isValid || isModalLoading}
                       >
                        {formik.isSubmitting ? <CircularProgress size={24} color="inherit" /> : (editID === "-1" ? t("text.save") : t("text.update"))}
                      </Button>
                    </Grid>
                    <Grid item xs={6} sm={3} md={2} lg={2}>
                      <Button
                        type="button"
                        fullWidth
                        variant="outlined"
                        color="secondary"
                        onClick={() => formik.resetForm()}
                        disabled={formik.isSubmitting || isModalLoading}
                       >
                        {t("text.reset")}
                      </Button>
                    </Grid>
                     {/* Optional: Add a cancel button */}
                    {/* <Grid item xs={12} sm={3} md={2} lg={2}>
                      <Button
                        type="button"
                        fullWidth
                        variant="text"
                        onClick={handleClose}
                       >
                        {t("text.cancel")}
                      </Button>
                    </Grid> */}
                </Grid>

                {/* Permissions Section */}
                <Typography variant="subtitle1" sx={{ mb: 1.5, fontWeight: 'medium' }}>
                  {t("text.AssignPermissions")}
                </Typography>

                {isModalLoading ? (
                     <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
                         <CircularProgress />
                     </Box>
                 ) : (
                    <TableContainer component={Paper} elevation={1} sx={{ maxHeight: "calc(95vh - 280px)", border: 1, borderColor: 'divider' }}> {/* Adjust maxHeight calculation based on other elements */}
                       <Table stickyHeader size="small" aria-label={t('ariaLabel.permissionsTable')}>
                         <TableHead>
                            <TableRow sx={{ '& th': { fontWeight: '600', backgroundColor: 'grey.200', py: 0.5 } }}> {/* Sticky header styling */}
                               <TableCell sx={{ textAlign: 'left', minWidth: { xs: 120, sm: 150 } }}>{t("text.MenuName")}</TableCell>
                               {permissionColumns.map((col) => (
                                 <TableCell key={col.key} align="center" sx={{ px: { xs: 0.5, sm: 1 }, width: { xs: 60, sm: 80 } }}> {/* Adjust padding/width */}
                                   <Tooltip title={t('selectAll', { permission: col.label })} arrow placement="top">
                                      <Stack direction="column" alignItems="center" spacing={0}>
                                        <Typography variant="caption" sx={{ lineHeight: 1.1, mb: -0.5 }}>{col.label}</Typography>
                                        <Checkbox
                                            size="small"
                                            // Determine indeterminate state if needed, otherwise just checked
                                            checked={childMenuRecords.length > 0 && childMenuRecords.every((item) => !!item[col.key])}
                                            indeterminate={
                                                childMenuRecords.length > 0 &&
                                                !childMenuRecords.every((item) => !!item[col.key]) && // Not all checked
                                                childMenuRecords.some((item) => !!item[col.key]) // But some are checked
                                            }
                                            onChange={(e) => handleSelectAll(col.key, e.target.checked)}
                                            inputProps={{ 'aria-label': t('ariaLabel.selectAllPermission', { permission: col.label }) }}
                                            sx={{ p: 0.5 }}
                                        />
                                      </Stack>
                                   </Tooltip>
                                 </TableCell>
                               ))}
                            </TableRow>
                         </TableHead>
                         <TableBody>
                           {childMenuRecords.length === 0 && !isModalLoading ? (
                             <TableRow>
                                <TableCell colSpan={permissionColumns.length + 1} align="center" sx={{ py: 4 }}>
                                    {t('text.NoPermissionsDataFound')} {/* More specific message */}
                                </TableCell>
                             </TableRow>
                            ) : (
                                childMenuRecords.map((row, index) => (
                                <TableRow
                                    key={row.menuId || `menu-${index}`}
                                    hover
                                    sx={{ '&:nth-of-type(odd)': { backgroundColor: 'action.hover' } }}
                                >
                                    <TableCell component="th" scope="row" sx={{ py: 0.5, px: 1 }}>
                                        {row.menuName}
                                    </TableCell>
                                    {permissionColumns.map((col) => (
                                        <TableCell key={col.key} align="center" sx={{ p: 0 }}> {/* Minimal padding */}
                                            <Checkbox
                                                size="small"
                                                checked={!!row[col.key]} // Ensure boolean value
                                                onChange={() => handleCheckboxChange(row.menuId, col.key)}
                                                name={`${col.key}_${row.menuId}`}
                                                inputProps={{ 'aria-label': t('ariaLabel.togglePermission', { permission: col.label, menu: row.menuName }) }}
                                                sx={{ p: 0.5 }} // Adjust padding if needed
                                            />
                                        </TableCell>
                                    ))}
                                </TableRow>
                                ))
                            )}
                         </TableBody>
                       </Table>
                    </TableContainer>
                 )}
             </form>
          </Box> {/* End scrollable content */}
        </Box>
      </Modal>
    </>
  );
}